import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQ_ITEMS = [
  {
    q: 'What is a HWID and why do I need one?',
    a: 'HWID (Hardware ID) is a unique identifier generated from your computer\'s hardware. Your license is locked to one HWID at a time to prevent key sharing. It is assigned automatically the first time you run the desktop app — you never need to enter it manually.',
  },
  {
    q: 'How do I activate my license key?',
    a: 'After purchase, you\'ll receive a license key. Log in to your account, open the desktop app once so your HWID gets registered, then go to your Dashboard → Activate Key and paste the key in. Your subscription starts immediately.',
  },
  {
    q: 'Can I switch to a new computer?',
    a: 'Yes. Contact an admin to request a HWID reset, which unlinks your license from the old device so you can activate it on the new one. Resets may be limited in frequency to prevent abuse.',
  },
  {
    q: 'What happens if I get banned?',
    a: 'Bans — whether issued manually or automatically by the Loader — are final and do not come with a refund. Any remaining subscription time is forfeited. See our Terms of Service and Rules pages for full details.',
  },
  {
    q: 'Do you offer refunds?',
    a: 'No. All purchases are final once a key has been generated and made available to you. Please review the product details and our Terms of Service before purchasing.',
  },
  {
    q: 'What is the invite system?',
    a: 'When enabled, registration requires an invite code. Active subscribers can request an invite code from their Dashboard, which an admin will review and approve or reject. This helps us keep the community controlled.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="px-4 py-20 border-t border-white/[0.06]">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="eyebrow mb-4">FAQ</span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-white mb-3 tracking-tight">
            Frequently asked questions
          </h2>
          <p className="text-gray-400">Everything you need to know before getting started.</p>
        </div>

        <div className="space-y-2.5">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className={`card overflow-hidden transition-colors duration-300 ${
                  isOpen ? 'border-brand-500/30' : 'hover:border-white/[0.12]'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className={`text-sm font-medium transition-colors ${isOpen ? 'text-white' : 'text-gray-200'}`}>
                    {item.q}
                  </span>
                  {/* Plusz-mínusz: a függőleges szár tűnik el nyitáskor */}
                  <span className={`relative flex-shrink-0 w-5 h-5 rounded-md border transition-all duration-300 ${
                    isOpen ? 'bg-brand-500/18 border-brand-400/30 text-brand-200' : 'border-white/[0.09] text-gray-500'
                  }`}>
                    <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2.5 h-px bg-current" />
                    <span className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-px h-2.5 bg-current
                                      transition-transform duration-300 ${isOpen ? 'scale-y-0' : 'scale-y-100'}`} />
                  </span>
                </button>

                {/*
                  A nyitás grid-sorral animál (0fr → 1fr) fix max-height helyett,
                  így hosszú válasz sem vágódik le.
                */}
                <div
                  className={`grid transition-all duration-300 ease-smooth ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-gray-400 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <p className="text-center text-sm text-gray-500 mt-10">
          Still stuck? Read the{' '}
          <Link to="/docs" className="link">documentation</Link>
          {' '}or ask in our{' '}
          <a href="https://discord.gg/Frbjdmtbrt" target="_blank" rel="noopener noreferrer" className="link">
            Discord
          </a>.
        </p>
      </div>
    </section>
  );
}
